import { render, staticRenderFns } from "./Cibles.vue?vue&type=template&id=22c496ea&"
import script from "./Cibles.vue?vue&type=script&lang=js&"
export * from "./Cibles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports